import React, { useCallback, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { l, BtnV2, Modal } from '@manychat/manyui'

import BulletListItem from 'components/BulletListItem/BulletListItem'
import { handleCatch } from 'shared/api/lib/errors/handlers'
import { manychatApi } from 'shared/api/requests/manychat'

export const TiktokPreviewButton = () => {
  const [query] = useSearchParams()

  const [isLoading, setIsLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const [previewInfo, setPreviewInfo] = useState({
    previewUsername: '',
    keyword: '',
  })

  const shareHash = query.get('share_hash')

  const fetchInstagramPreviewInfo = useCallback(async () => {
    if (!shareHash) {
      return
    }

    try {
      setIsLoading(true)

      const {
        data: { channels },
      } = await manychatApi.getPreviewState({
        query: {
          share_hash: shareHash,
        },
      })

      setPreviewInfo({
        keyword: channels?.tiktok?.preview_keyword ?? '',
        previewUsername: channels?.tiktok?.username ?? '',
      })
      setIsModalOpen(true)
    } catch (error) {
      handleCatch(error)
    } finally {
      setIsLoading(false)
    }
  }, [shareHash])

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <Modal
        open={isModalOpen}
        width={460}
        onRequestClose={closeModal}
        disableCloseButton
        noContentPadding
      >
        <div className="p-x-lg p-y-md">
          <BulletListItem n={1} className="m-b-md">
            {l.translate(
              'Open TikTok and send a Direct Message with this three-digits code to your <a class="text-primary" rel="noreferrer"  href="https://www.tiktok.com/@{ttAccountName}" target="_blank">@{ttAccountName}</a> account from a different TikTok account',
              {
                ttAccountName: previewInfo.previewUsername,
              },
            )}
            <div className="bg-default p-y-xxs m-t-xs text-heading-2 text-center rounded">
              {previewInfo.keyword}
            </div>
          </BulletListItem>

          <BulletListItem n={2} className="m-b-lg">
            {l.translate('Wait for the automatic reply message  🎉')}
          </BulletListItem>

          <div className="d-flex justify-center">
            <BtnV2 size="large" variant="primary" onClick={closeModal}>
              {l.translate('I Did It!')}
            </BtnV2>
          </div>
        </div>
      </Modal>

      <BtnV2
        onClick={fetchInstagramPreviewInfo}
        loading={isLoading}
        size="large"
        leftIcon="TikTokChannel"
      >
        <span>{l.translate('Preview')}</span>
      </BtnV2>
    </>
  )
}
